// extracted by mini-css-extract-plugin
export default {"userMessage":"userMessage_h5r5B","sameSide":"sameSide_gIlV9","aiMessage":"aiMessage_RFioi"};